import { Box, Avatar, Typography } from '@mui/material';

/**
 * Non-interactive identity block at the top of the user menu (#1299).
 * Rendered as role="presentation" so MUI's MenuList arrow navigation and
 * the menuitem count skip it entirely (the old version was a disabled
 * MenuItem, which still occupied a slot).
 */
export default function IdentityHeader({ name, email, initial }) {
  return (
    <li role="presentation">
      <Box
        sx={(theme) => ({
          display: 'flex',
          alignItems: 'center',
          gap: `${theme.ds.space[4]}px`,
          px: 2,
          py: `${theme.ds.space[4]}px`,
          cursor: 'default',
        })}
      >
        <Avatar
          sx={(theme) => ({
            width: 36,
            height: 36,
            fontSize: 15,
            fontWeight: theme.ds.font.weightMedium,
            background: `linear-gradient(135deg, ${theme.palette.interactive}, ${theme.palette.accentDeep})`,
            color: theme.palette.interactiveOn,
          })}
        >
          {initial}
        </Avatar>
        <Box sx={{ minWidth: 0 }}>
          {name && (
            <Typography
              noWrap
              sx={(theme) => ({
                fontSize: theme.ds.font.row,
                fontWeight: theme.ds.font.weightMedium,
                color: theme.palette.text.primary,
                maxWidth: 200,
              })}
            >
              {name}
            </Typography>
          )}
          {email && (
            <Typography
              noWrap
              sx={(theme) => ({
                fontSize: theme.ds.font.dim,
                color: theme.palette.text.dim,
                maxWidth: 200,
              })}
            >
              {email}
            </Typography>
          )}
        </Box>
      </Box>
    </li>
  );
}
